import { render, staticRenderFns } from "./VFNPGGDG.vue?vue&type=template&id=1be19b7c&scoped=true"
import script from "./VFNPGGDG.vue?vue&type=script&lang=js"
export * from "./VFNPGGDG.vue?vue&type=script&lang=js"
import style0 from "./VFNPGGDG.vue?vue&type=style&index=0&id=1be19b7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be19b7c",
  null
  
)

export default component.exports